var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrResult(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "88DC1EE9-3E24-4975-8C5A-C67B953FCBBB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walk-in/out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-level-entrance-Copy",
    transform: "translate(-220.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(79.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "human-id",
    transform: "translate(13.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "details",
    transform: "translate(128.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5f00a0",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 3.33333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/photo-stack",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(5.500000, 5.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10.257485 C9.61876557,10.257485 10.2974015,10.3473045 11.0359281,10.5269461 C11.8742557,10.736528 12.5528916,11.0159663 13.0718563,11.3652695 C13.6906219,11.7744531 14,12.2335304 14,12.742515 L14,14 L4,14 L4,12.742515 C4,12.2335304 4.30937814,11.7744531 4.92814371,11.3652695 C5.44710838,11.0159663 6.12574431,10.736528 6.96407186,10.5269461 C7.7025985,10.3473045 8.38123443,10.257485 9,10.257485 Z M9,9 C8.55089596,9 8.13672844,8.88772567 7.75748503,8.66317365 C7.37824162,8.43862163 7.07634843,8.13672844 6.85179641,7.75748503 C6.62724439,7.37824162 6.51497006,6.9640741 6.51497006,6.51497006 C6.51497006,6.06586602 6.62724439,5.64670853 6.85179641,5.25748503 C7.07634843,4.86826153 7.37824162,4.56137837 7.75748503,4.33682635 C8.13672844,4.11227433 8.55089596,4 9,4 C9.44910404,4 9.86327156,4.11227433 10.242515,4.33682635 C10.6217584,4.56137837 10.9236516,4.86826153 11.1482036,5.25748503 C11.3727556,5.64670853 11.4850299,6.06586602 11.4850299,6.51497006 C11.4850299,6.9640741 11.3727556,7.37824162 11.1482036,7.75748503 C10.9236516,8.13672844 10.6217584,8.43862163 10.242515,8.66317365 C9.86327156,8.88772567 9.44910404,9 9,9 Z",
    id: "icon/person/black",
    fill: "#5f00a0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#5f00a0",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10.257485 C9.61876557,10.257485 10.2974015,10.3473045 11.0359281,10.5269461 C11.8742557,10.736528 12.5528916,11.0159663 13.0718563,11.3652695 C13.6906219,11.7744531 14,12.2335304 14,12.742515 L14,14 L4,14 L4,12.742515 C4,12.2335304 4.30937814,11.7744531 4.92814371,11.3652695 C5.44710838,11.0159663 6.12574431,10.736528 6.96407186,10.5269461 C7.7025985,10.3473045 8.38123443,10.257485 9,10.257485 Z M9,9 C8.55089596,9 8.13672844,8.88772567 7.75748503,8.66317365 C7.37824162,8.43862163 7.07634843,8.13672844 6.85179641,7.75748503 C6.62724439,7.37824162 6.51497006,6.9640741 6.51497006,6.51497006 C6.51497006,6.06586602 6.62724439,5.64670853 6.85179641,5.25748503 C7.07634843,4.86826153 7.37824162,4.56137837 7.75748503,4.33682635 C8.13672844,4.11227433 8.55089596,4 9,4 C9.44910404,4 9.86327156,4.11227433 10.242515,4.33682635 C10.6217584,4.56137837 10.9236516,4.86826153 11.1482036,5.25748503 C11.3727556,5.64670853 11.4850299,6.06586602 11.4850299,6.51497006 C11.4850299,6.9640741 11.3727556,7.37824162 11.1482036,7.75748503 C10.9236516,8.13672844 10.6217584,8.43862163 10.242515,8.66317365 C9.86327156,8.88772567 9.44910404,9 9,9 Z",
    id: "icon/person/black",
    fill: "#5f00a0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#5f00a0",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10.257485 C9.61876557,10.257485 10.2974015,10.3473045 11.0359281,10.5269461 C11.8742557,10.736528 12.5528916,11.0159663 13.0718563,11.3652695 C13.6906219,11.7744531 14,12.2335304 14,12.742515 L14,14 L4,14 L4,12.742515 C4,12.2335304 4.30937814,11.7744531 4.92814371,11.3652695 C5.44710838,11.0159663 6.12574431,10.736528 6.96407186,10.5269461 C7.7025985,10.3473045 8.38123443,10.257485 9,10.257485 Z M9,9 C8.55089596,9 8.13672844,8.88772567 7.75748503,8.66317365 C7.37824162,8.43862163 7.07634843,8.13672844 6.85179641,7.75748503 C6.62724439,7.37824162 6.51497006,6.9640741 6.51497006,6.51497006 C6.51497006,6.06586602 6.62724439,5.64670853 6.85179641,5.25748503 C7.07634843,4.86826153 7.37824162,4.56137837 7.75748503,4.33682635 C8.13672844,4.11227433 8.55089596,4 9,4 C9.44910404,4 9.86327156,4.11227433 10.242515,4.33682635 C10.6217584,4.56137837 10.9236516,4.86826153 11.1482036,5.25748503 C11.3727556,5.64670853 11.4850299,6.06586602 11.4850299,6.51497006 C11.4850299,6.9640741 11.3727556,7.37824162 11.1482036,7.75748503 C10.9236516,8.13672844 10.6217584,8.43862163 10.242515,8.66317365 C9.86327156,8.88772567 9.44910404,9 9,9 Z",
    id: "icon/person/black",
    fill: "#5f00a0",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrResult);
export default __webpack_public_path__ + "static/media/fr_result.188917ce4d1f39beba8a925fa4d93b9b.svg";
export { ForwardRef as ReactComponent };